<template>
  <v-dialog
    v-model="referredOnDialog"
    persistent
    scrollable
    max-width="500"
  >
    <template #activator="{ on, attrs }">
      <v-btn
        small
        v-bind="attrs"
        v-on="on"
        @click="referredOnDialogInit"
      >
        <v-icon dark>
          mdi-calendar-clock
        </v-icon>
      </v-btn>
    </template>

    <v-card>
      <v-card-title class="title white--text secondary">
        {{ $t('supportTicketDialogReferredOn.title') }}
      </v-card-title>
      <v-card-text>
        <Loading :loading="!loaded" />

        <v-container
          v-if="loaded && referredOnModel"
          fluid
        >
          <v-row>
            <v-col>
              <v-datetime-picker
                v-model="referredOnModel.data.referredOn"
                use-iso
                :label="$t('common.timeLabel')"
                date-format="yyyy-MM-dd"
                time-format="HH:mm:ss"
                :time-picker-props="timeProps"
              >
                <template slot="dateIcon">
                  <v-icon>mdi-calendar</v-icon>
                </template>
                <template slot="timeIcon">
                  <v-icon>mdi-clock</v-icon>
                </template>
                <template
                  slot="actions"
                  slot-scope="{ parent }"
                >
                  <v-btn
                    outlined
                    color="primary"
                    @click.native="parent.cancelHandler"
                  >
                    {{ $t('common.cancel') }}
                  </v-btn>
                  <v-btn
                    color="secondary"
                    @click="parent.okHandler"
                  >
                    OK
                  </v-btn>
                </template>
              </v-datetime-picker>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              {{ $t('common.currentAssigned') }}: <br>
              {{ referredOnModel.data.currentAssignedTo }}
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-select
                v-model="referredOnModel.data.newAssignedToId"
                :items="referredOnModel.metadata.assignedTos"
                item-text="text"
                item-value="value"
                :label="$t('supportTicketDialogReferredOn.selectAssigned')"
                outlined
                dense
                @change="hasChanged = true"
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-textarea
                v-model="referredOnModel.data.comment"
                :label="$t('common.comment')"
                outlined
              />
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
      <v-divider />

      <v-card-actions>
        <v-spacer />
        <v-btn
          outlined
          color="primary"
          @click="referredOnDialogCancel"
        >
          {{ $t('common.cancel') }}
        </v-btn>
        <v-btn
          color="secondary"
          :loading="saving"
          :disabled="!hasChanged"
          @click="referredOnDialogSave"
        >
          {{ $t('common.save') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import Loading from '@/components/Loading'

export default {
  name: "SupportTicketDialogReferredOn",
  components: {
    Loading
  },
  props: {},
  data() {
    return {
      referredOnModel: Object,
      referredOnDialog: false,
      loaded: false,
      saving: false,
      hasChanged: false,
      timeProps: {
        format: "24hr",
        useSeconds: true,
      },
    };
  },
  methods: {
    referredOnDialogInit: function () {
      this.loaded = false;
      this.referredOnDialog = true;

      this.$api.get(`supportticket/ReferredOn/${this.$route.params.id}`).then((response) => {
        this.referredOnModel = response.data;
        this.loaded = true;
      });
    },
    referredOnDialogSave: function () {
      this.saving = true;

      this.$api.put(`supportticket/ReferredOn/${this.$route.params.id}`, this.referredOnModel.data).then((response) => {
        if (response.data.success) {
          this.saving = false;
          this.ReferredOnDialog = false;
          this.$emit("saved");
        } else {
          //TODO: Error handle...
        }
      });
    },
    referredOnDialogCancel: function () {
      this.referredOnModel = null;
      this.referredOnDialog = false;
      this.hasChanged = false;
    },
  },
};
</script>